
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class FormatMasterGrid extends Serenity.EntityGrid<FormatMasterRow, any> {
        protected getColumnsKey() { return 'OMS.FormatMaster'; }
        protected getDialogType() { return FormatMasterDialog; }
        protected getIdProperty() { return FormatMasterRow.idProperty; }
        protected getInsertPermission() { return FormatMasterRow.insertPermission; }
        protected getLocalTextPrefix() { return FormatMasterRow.localTextPrefix; }
        protected getService() { return FormatMasterService.baseUrl; }
        private rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }

}